import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

import {COMPANY_LEVEL} from "../../../../../../../xpresso/src/routes/common/logic/user-level";
import {isDevQuan}     from "../../../../../debug/is-dev-quan";

export const AltNameTypeConfig = ({next}) => cs(
    consumeContext("company"),
    consumeContext("session"),
    consumeContext("branch"),
    consumeContext("userLevels"),
    ({company, session, branch, userLevels}) => {
        const branch1 = branch ?? session.data?.branch;
        if (isDevQuan() && !branch1) {
            return null;
        }
        const resident = (
            userLevels.userLevel === COMPANY_LEVEL ? (
                company?.prefs?.defaultOrResident
            ) : branch1?.defaultOrResident === 1 ? (
                true
            ) : branch1?.defaultOrResident === 0 ? (
                false
            ) : (
                company?.prefs?.defaultOrResident
            )
        );
        return next(
            resident ? "or_resident" : "owner"
        );
    },
);